import api from './api'
import { loggerService, toLoggableError } from './logger.service'
import type {
  PaymentMethodOption,
  PaymentMethodsListResponse,
  PaymentMethodsSettings,
  PaymentMethodsSettingsResponse,
} from '@/types/paymentMethods.types'

/**
 * Enabled methods for payment pickers. Returns null on failure so callers keep
 * their built-in fallback labels instead of blocking the form.
 */
export async function fetchPaymentMethods(): Promise<PaymentMethodOption[] | null> {
  try {
    const response = await api.get<PaymentMethodsListResponse>('/api/v1/payment-methods/')
    return response.data.data
  } catch (err) {
    void loggerService.logError(toLoggableError(err), { action: 'payment_methods_fetch' })
    return null
  }
}

/** Full five-method configuration for the tenant settings page. */
export async function fetchPaymentMethodsSettings(): Promise<PaymentMethodsSettings> {
  const response = await api.get<PaymentMethodsSettingsResponse>(
    '/api/v1/settings/payment-methods',
  )
  return response.data.data
}

/** Replace labels, enabled flags and order in one save. */
export async function savePaymentMethodsSettings(
  settings: PaymentMethodsSettings,
): Promise<PaymentMethodsSettings> {
  const response = await api.patch<PaymentMethodsSettingsResponse>(
    '/api/v1/settings/payment-methods',
    settings,
  )
  return response.data.data
}
